import React from "react";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";

import { signInWithGoogle } from "../../thirdparty/firebaseInit";

const LoginPage = () => {

    React.useEffect(() => {

    }, []);

    const handleLogin = () => {
        signInWithGoogle();
    }

    return (
        <div
            className="d-flex"
        >
            <div>
                <div>
                    <h2>Login</h2>
                </div>
                <Button
                    onClick={handleLogin}
                >
                    Login
                </Button>
            </div>
        </div>
    )
}

export default LoginPage;
